<template>
  <div class="shareTips">
    <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>
    <div class="drawTipsBox" @click="handleClose">
      <img src="../assets/weixin.png">
    </div>
  </div>
</template>

<script>
export default {
  name: "share",
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.shareTips{width: 100%; height: 100%; overflow-y: auto; position: absolute; z-index: 30; top:0; left: 0; background: rgba(0,0,0,0.8)}
.shareTips .drawTipsBox{width: 100%; height: 90%; text-align: right}
.shareTips .drawTipsBox img{width: 50%;margin-right: 5%; }

</style>



// WEBPACK FOOTER //
// src/components/shareTips.vue